<template>
<v-container id="grid" fluid tag="section">
  <div class="page-shell">
    <notification-dialog/>
    <dialog-form-process/>
    <filter-process-form/>
    <v-card class="page-card">
      <v-toolbar color="primary" class="page-toolbar">
        <v-toolbar-title>Partes de Proceso</v-toolbar-title>
        <v-btn v-if="canCreate" color="white" variant="flat" class="toolbar-add-button" @click="addProcess()">Nuevo Proceso</v-btn>
      </v-toolbar>
      <div class="table-wrapper">
        <table-process/>
      </div>
    </v-card>
  </div>
</v-container>
</template>
<script>
import AddEditProcessFormVue from './AddEditProcessForm'
import ProcessTableVue from './ProcessTable'
import NotificationDialog from '../Common/NotificationDialog'
import FilterProcessForm from './FilterProcessForm'

export default {
  name: 'Process',
  components: {
    'dialog-form-process': AddEditProcessFormVue,
    'table-process': ProcessTableVue,
    'notification-dialog': NotificationDialog,
    'filter-process-form': FilterProcessForm
  },

  data: () => ({
    successMsg: ''
  }),
  computed: {
    canCreate () { return this.$store.getters['authModule/hasPermission']('plant.processes.create') }
  },

  beforeUnmount () {
    this.$store.commit('processModule/resetState')
  },

  methods: {
    addProcess () {
      this.$store.dispatch('processModule/setDialogActived', true)
    }
  }
}
</script>
